import { render, staticRenderFns } from "./SettlementSummary.vue?vue&type=template&id=dcc00ed6"
import script from "./SettlementSummary.vue?vue&type=script&lang=js"
export * from "./SettlementSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports